module.exports = __webpack_public_path__ + "static/media/lcs_60y_n-1.4ab6dcf7.csv";